import './BackBtn.css';

const BackBtn = () => {
    return ( 
        <div className="backbtn">
            <button>BACK</button>
        </div>
     );
}
 
export default BackBtn;